module.exports = __webpack_public_path__ + "static/media/082-no sound.5500e92f.svg";